import { strollers_api_v2_get_strollers_url } from 'mk/urls/functions';
import {
    strollersFetchApi,
    StrollersFetchNormalizedResponse,
    StrollersFetchTriggerAction,
    STROLLERS_LIST_FETCH_TRIGGER,
} from 'mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersList.actions';
import { LinkedObjects } from 'mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.actions';
import { normalizeError, XHRAction } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('strollers/BrandsStrollersList.sagas');

interface FetchApiResponse {
    body: {
        entities: StrollersFetchNormalizedResponse['entities'];
        result: StrollersFetchNormalizedResponse['result'];
        hasMore: boolean;
        count: number;
        forumPostLinkedObjects: LinkedObjects;
    };
}

function* fetchStrollers({ slug, offset, xhr }: StrollersFetchTriggerAction & XHRAction) {
    yield put(strollersFetchApi.request(slug, offset));

    try {
        const response: FetchApiResponse = yield call(() =>
            xhr.get(strollers_api_v2_get_strollers_url(slug, { offset })),
        );

        yield put(
            strollersFetchApi.success(
                slug,
                offset,
                response.body.hasMore,
                response.body.count,
                response.body.forumPostLinkedObjects,
                {
                    entities: response.body.entities,
                    result: response.body.result,
                },
            ),
        );
    } catch (error) {
        logger.error(error);
        yield put(strollersFetchApi.failure(slug, offset, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(STROLLERS_LIST_FETCH_TRIGGER, fetchStrollers)]);
}
